export class PageSort {

    public property: string;

    public direction: string;
}